<template>
    <div class="loading-box match-card-box" :class="type">
        <div class="loading-item mb-30px loading-match-card" v-for="(i,index) in 2" :key="index">
            <div class="display-flex-align-center mb-1rem">
                <div class="circle circle-big animation mr-05rem"></div>
                <div>
                    <div class="pill w-36px mb-6px animation"></div>
                    <div class="display-flex-align-center gap-27px">
                        <div class="pill w-87px animation"></div>
                        <div class="circle circle-small animation"></div>
                    </div>
                </div>
            </div>

            <div class="space-between loading-match-box" v-for="(i2,index2) in 5" :key="index2">
                <div class="pill pill-4 pill-18 animation flex-shrink mb-12px"></div>
                <div class="flex-column-space-between">
                    <div class="square animation mb-4px"></div>
                    <div class="pill w-50px animation"></div>
                </div>
                <div class="display-flex-align-center align-items-end gap-14px mb-26px">
                    <div class="flex-column-space-between">
                        <div class="display-flex-align-center mb-4px gap-3px">
                            <div class="pill-column-red-card animation"></div>
                        </div>
                        <div class="pill-column-score-card animation"></div>
                    </div>
                    <div class="flex-column-space-between">
                        <div class="display-flex-align-center mb-4px gap-3px">
                        </div>
                        <div class="pill-column-score-card animation"></div>
                    </div>
                    <div class="flex-column-space-between">
                        <div class="display-flex-align-center mb-4px gap-3px">
                            <div class="pill-column-red-card animation"></div>
                            <div class="pill-column-red-card animation"></div>
                        </div>
                        <div class="pill-column-score-card animation"></div>
                    </div>
                </div>
                <div class="flex-column-space-between">
                    <div class="square animation mb-4px"></div>
                    <div class="pill w-50px animation"></div>
                </div>
                <div class="pill pill-4 pill-18 animation flex-shrink mb-12px"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingHomeMatchCard',
        props: {
            type: String
        }
    }
</script>

<style scoped src="../../assets/css/loading/index.css"></style>